import React from 'react';
import { GreySections } from '../GreySections';
import { useAppSelector } from '../../../../../redux/hooks';
import { rootState } from '../../../../../redux/store';
import { INodeWithPath } from '../../../../../interface/interfaces';
import { DetailCard } from './DetailCard';
import { generateTimestamp } from '../../../../../utils/createTimestamp';
import { SpacingCustom } from '../../../../layout/Spacing/SpacingCustom';
import { FlexCenter } from '../../../../layout/FlexCenter/FlexCenter';
import { ScrollY } from '../../../../layout/Scroll/ScrollY';

export const Details = () => {
    const { dataAllChildrensPerNode } = useAppSelector((state: rootState) => state.filteredChildrenNodesPerSelection);

    // useEffect(()=>{
    //     if(dataAllChildrensPerNode){
    //         console.log('SELECTED NODES: ', dataAllChildrensPerNode[0])
    //     }
    // },[dataAllChildrensPerNode])

    const detailsCard = dataAllChildrensPerNode.map((item: INodeWithPath, idx: number) => {
        return <DetailCard key={idx} fileIcon={'Edit'} fileName={item.Name} commitData={generateTimestamp()} version={'1.0'} />;
    });

    return (
        <GreySections title={'File activity log'} closeSection={false} hasArrow={false}>
            <SpacingCustom paddingTop={1}>
                <div style={{ height: 'calc(100vh - 17.8rem)' }}>
                    <ScrollY>
                        <SpacingCustom paddingRight={1}>
                            <FlexCenter position="between" gap={0.5}>
                                {detailsCard}
                            </FlexCenter>
                        </SpacingCustom>
                    </ScrollY>
                </div>
            </SpacingCustom>
        </GreySections>
    );
};
